
export default {
  props: {
    data: {
      type: Object,
      required: true,
      default: () => null,
    },
  },

  head() {
    return {
      script: [
        {
          type: 'module',
          crossorigin: '', // adds crossorigin="" attribute
          src: this.data.framework_script_url,
        },
      ],
    }
  },

  mounted() {
    // Nuxt SSR safety (mounted only runs client-side, but guard anyway)
    if (typeof window === 'undefined') return

    // Create the web component
    const el = document.createElement('scroll-story')
    this._scrollStoryEl = el

    // Initial attributes (use your attribute names; change if the WC expects kebab-case)
    const d = this.data || {}
    el.setAttribute('scrollstoryid', d.scroll_story_id || '')
    el.setAttribute('lang', d.lang || '')
    el.setAttribute('theme', d.theme || '')

    // If the web component supports a full object via property, you can also do:
    // el.data = d

    // Mount into the container
    this.$refs.storyContainer.appendChild(el)
  },

  watch: {
    // Keep attributes in sync if the prop changes
    data: {
      immediate: false,
      deep: true,
      handler(d) {
        const el = this._scrollStoryEl
        if (!el) return
        el.setAttribute('scrollstoryid', d?.scroll_story_id || '')
        el.setAttribute('lang', d?.lang || '')
        el.setAttribute('theme', d?.theme || '')
        // If using property instead of attributes:
        // el.data = d || null
      },
    },
  },

  beforeDestroy() {
    // Clean up the inserted element
    if (this._scrollStoryEl && this._scrollStoryEl.parentNode) {
      this._scrollStoryEl.parentNode.removeChild(this._scrollStoryEl)
    }
    this._scrollStoryEl = null
  },
}
